<template>
  <div class="app">
    <headersection />
    <features />
    <carousel firstslide="https://firebasestorage.googleapis.com/v0/b/mediathek-7f332.appspot.com/o/autotransport%2Fheader%2Fb-(11).png?alt=media&token=5cd14a20-37c8-42b0-9caf-ce437549f878" secondslide="https://firebasestorage.googleapis.com/v0/b/mediathek-7f332.appspot.com/o/autotransport%2Fheader%2Fb-(11).png?alt=media&token=5cd14a20-37c8-42b0-9caf-ce437549f878" thirdslide="https://firebasestorage.googleapis.com/v0/b/mediathek-7f332.appspot.com/o/autotransport%2Fheader%2Fb-(11).png?alt=media&token=5cd14a20-37c8-42b0-9caf-ce437549f878" />
    <contact id="preislisteid" title="Preisliste anfordern" untertitel="Fordern Sie völlig unverbindlich unsere Preisliste an und überzeugen Sie sich von unserem Angebot.
„Kompetenz und Fairness in Preis und Leistung“
... damit Sie sich voll und ganz auf den Kauf Ihres Traumfahrzeuges konzentrieren können.
" />
  </div>
</template>

<script>
import {
  mdbContainer,
  mdbRow,
  mdbCol,
  mdbIcon,
  mdbNavItem,
  mdbListGroup,
  mdbEdgeHeader
} from "mdbvue";
import headersection from "@/components/headersection"
import features from "@/components/features"
import contact from "@/components/contact";
import carousel from "@/components/carousel";

export default {
  name: "HomeView",
  components: {
    mdbContainer,
    mdbRow,
    mdbCol,
    mdbIcon,
    mdbNavItem,
    mdbListGroup,
    mdbEdgeHeader,
    headersection,
    features,
    contact,
    carousel
  }
};
</script>